import React from "react";
import "./Client.css";
import { deleteClient } from "../../../../api/api";
import { Spinner } from "../../../../components/spinner/Spinner";

interface IClientProps {
    data: {
        id: string,
        name: string,
        date1: string,
        date2: string,
        avatarUrl: string,
        waitLoading?: boolean,
        customAvatarUrl: string
    },
    isOpen?: boolean;
    onOpen: ()=>void;
    onEdit: ()=>void;
}

export const Client = ({data, isOpen, onOpen, onEdit}: IClientProps) => {
    const isSelected = isOpen;

    return (
        <div className={`client client--closed ${!isSelected ? '' : 'client--selected'}`} onClick={onOpen}>
            <div className="client_head">
                <div className="client_avatar client_avatar_1" style={{backgroundImage: `url(${data.customAvatarUrl || data.avatarUrl})`}}>

                </div>
                {/*<div onClick={()=>deleteClient(data.id)}>delete</div>*/}
                <div className="client_info">
                    <div className="client_info_name">
                        {data.name || 'Laur Somey'} 
                    </div>
                    <div className="client_info_dates">
                        <div className="client_info_date client_info_date_1">
                            {data.date1 || ''}
                        </div>
                        <div className="client_info_date client_info_date_2">
                            {data.date2 || ''}
                        </div>
                    </div>
                </div>
            </div>
            {data.waitLoading ? 
            <div className="client_loader_overlay"><Spinner></Spinner></div>: ""}
        </div>
    )
}